import { State } from "./State";
export class Cell {
    get isChecked() {
        return this.checked.value;
    }
    constructor(number, checked) {
        this.number = number;
        this.checked = new State(checked);
    }
    check() {
        if (this.checked.value) {
            return;
        }
        this.checked.set(true);
    }
}
